import { useMutation, useQueryClient } from "@tanstack/react-query";
import { axios } from "@/client/libs/axios";
import qs from "qs";
import type { ProvidersList } from "@reactive-resume/dto";

const createProvider = async (name: string) => {
  const response = await axios.post("/provider", { name });
  return response.data;
};

export const useCreateProvider = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (name: string) => createProvider(name),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["providers"] });
    },
  });
};
